
import { WOW } from "wowjs";

(function ($) {
	$(document).ready(function () {

		const wow = new WOW();

		wow.init();

		$(".menu-item-has-children").find(".dropdown-toggle").attr("data-toggle", "");

		let body = $( 'body' );
		let desktopMenuBreakpoint = parseInt($(":root").css("--desktop-menu-breakpoint"));

		/**
		 * Back to top button - scroll functionality
		 */
		$("#back-to-top").on("click", function(){
			$("html, body").animate({
				scrollTop: 0,
			}, 400);

			return false;
		});

		/**
		 * Carousel - Set equal heights
		 */
		function carouselEqualHeights() {
			$('.carousel-block').each(function () {
				var items 		= $('.carousel-item', this);
				let maxHeight 	= 0;

				// Show all slides
				$.each( items, function( i, slide ) {
					$( slide ).addClass( 'active' );
				});

				// Get the height of the tallest caption and save it
				// Desktop
				if(window.innerWidth >= 993) {
					$.each( items, function() {
						let caption 		= $('.carousel-caption', this);
						let captionHeight 	= caption.outerHeight();

						if ( captionHeight > maxHeight ) {
							maxHeight = captionHeight;
						}
					});

					// Apply the max height to all captions
					$.each( items, function() {
						let caption = $(this);
						caption.css('min-height', maxHeight + 450);

						// Remove .active from all slides
						$( this ).removeClass( 'active' );
					});

					// Mobile
				} else {
					$.each( items, function() {
						let caption 		= $(this);
						let captionHeight 	= caption.css('height', 'auto').outerHeight();

						if ( captionHeight > maxHeight ) {
							maxHeight = captionHeight;
						}
					});

					// Apply the max height to all captions
					$.each( items, function() {
						let caption = $(this);
						caption.css('height', maxHeight);

						// Remove .active from all slides
						$( this ).removeClass( 'active' );
					});
				}

				// Add the active class back to the first slide
				$('.carousel-block .carousel-inner .carousel-item:first-of-type').addClass('active');
			});
		}

		// Run equal heights
		carouselEqualHeights();

		/**
		 * Full height header/carousel/quick links
		 */
		let carouselHeight 		= $('.home .carousel-block .carousel-inner').height();
		let quickLinksHeight 	= $('.home .quick-links-block').height();

		if(window.innerWidth >= 993) {
			$.each( $('.carousel-block .carousel-item'), function() {
				let caption = $(this);
				caption.css('max-height', carouselHeight - quickLinksHeight);
			});
		}

		/**
		 * Add class to body when sticky header is showing
		 */
		if ($(window).scrollTop() > 50){
			body.addClass('sticky-header');
			$('header').addClass('sticky');
		} else {
			body.removeClass('sticky-header');
			$('header').removeClass('sticky');
		}
		$(window).scroll(function(){
			if ($(window).scrollTop() > 50){
				$('body').addClass('sticky-header');
				$('header').addClass('sticky');
			} else {
				$('body').removeClass('sticky-header');
				$('header').removeClass('sticky');
			}
		});

		/**
		 * Mobile menu
		 */

		$("header .js-mobile-menu-toggle").on("click", function(){
			$("body").toggleClass("no-scroll");
		});

		$("#header-navbar-menu-wrapper")
			.find(".navbar-nav .menu-item.menu-item-has-children > .dropdown-menu").each(function(){

			if($(window).width() < desktopMenuBreakpoint){

				$(this).addClass("mobile-menu-sub-level-panel");

				let subLevelTitleElement = $("<h3>").html($(this).siblings(".nav-link").html().trim());

				$(this).prepend(
					$("<li>")
						.addClass("menu-item sub-level-panel-heading")
						.append(subLevelTitleElement)
				);

			}

		});

		$("#header-navbar-menu-wrapper.navbar-collapse")
			.on("show.bs.collapse", function(){

				let headerBannerHeight = 0;

				$("body > header").children().each(function(){
					headerBannerHeight += $(this).outerHeight();
				});

				if(!$("body > header").hasClass("sticky")){
					headerBannerHeight += (parseInt($("html").css("margin-top")) - $("html").scrollTop());
				}

				$(this).css("--mobile-menu-height", ($(window).outerHeight() - headerBannerHeight) + "px");

				$(this).children(".header-navbar-menu-inner-wrap").addClass("curr-level");

			})
			.on("hidden.bs.collapse", function(){

				$(this).find(".curr-level").removeClass("curr-level");

				$(this).find(".show").removeClass("show fade-in");

				$(this).find(".mobile-menu-sub-level-panel").scrollTop(0);

				$(this).find(".js-menu-back-btn").data("depth-level", 0);

			});

		let mobileMenuBackBtnWrap = $("#header-navbar-menu-wrapper").find(".back-btn-wrap");
		let mobileMenuBackBtn = mobileMenuBackBtnWrap.children(".js-menu-back-btn");

		mobileMenuBackBtn.data("depth-level", 0);

		mobileMenuBackBtn.on("click", function(){

			$(this).data("depth-level", ($(this).data("depth-level") - 1));

			let currentMenuPanel = $("#header-navbar-menu-wrapper").find(".mobile-menu-sub-level-panel.curr-level");

			currentMenuPanel.parent().closest(".mobile-menu-sub-level-panel").addClass("curr-level");

			currentMenuPanel.addClass("fade-out").removeClass("show fade-in curr-level");

			if($(this).data("depth-level") <= 0){

				$("#header-navbar-menu-wrapper").find(".header-navbar-menu-inner-wrap").addClass("curr-level");

				$(this)
					.data("depth-level", 0)
					.parent()
					.addClass("fade-out")
					.removeClass("show fade-in");

			}

		});

		$("#header-navbar-menu-wrapper").find(".navbar-nav .menu-item.menu-item-has-children > .nav-link")
			.on("click", function (evt) {

				evt.preventDefault();

				$("#header-navbar-menu-wrapper").find(".curr-level").removeClass("curr-level");

				$(this).siblings(".mobile-menu-sub-level-panel")
					.scrollTop(0)
					.removeClass("fade-out")
					.addClass("show fade-in curr-level");

				if(window.innerWidth < 992) {
					if (mobileMenuBackBtn.data("depth-level") === 0) {

						mobileMenuBackBtnWrap
							.removeClass("fade-out")
							.addClass("show fade-in");
					} else {

						$(this).siblings(".mobile-menu-sub-level-panel")
							.css("top", $(this).closest(".mobile-menu-sub-level-panel, .header-navbar-menu-inner-wrap").scrollTop());

					}
				}

				mobileMenuBackBtn.data("depth-level", (mobileMenuBackBtn.data("depth-level") + 1));

				return false;

			});

		/**
		 * Archive - Category count
		 */
		initializeCheckboxDropdowns($(".checkbox-dropdown"));

		// Clear button - reset text
		$(".btn-clear-filter").on("click", function (evt) {
			evt.preventDefault();

			$(".checkbox-dropdown")
				.find("input:checked")
				.prop("checked", false);

			$(".checkbox-dropdown").each(function () {
				updateCheckboxDropdownState($(this));
			});
		});

		function updateCheckboxDropdownState(dropdown, numSelected = null) {
			let dropdownMenu = dropdown.find(".dropdown-menu");

			if (numSelected == null) {
				numSelected = dropdown.find("input:checked").length;
			}

			if (numSelected > 0) {
				dropdown.find(".js-clear-selections-btn").addClass("show");

				if (dropdownMenu.is(".show")) {
					dropdownMenu.css(
						"max-height",
						dropdownMenu.data("opened-height-with-clear")
					);
				}

				let numSelectedLabel =
					dropdown.find(".dropdown-toggle").data("selected-label") +
					" &bull; " +
					numSelected;

				dropdown.find(".dropdown-toggle").html(numSelectedLabel);
			} else {
				dropdown.find(".js-clear-selections-btn").removeClass("show");

				if (dropdownMenu.is(".show")) {
					dropdownMenu.css(
						"max-height",
						dropdownMenu.data("opened-height")
					);
				}

				dropdown
					.find(".dropdown-toggle")
					.text(dropdown.find(".dropdown-toggle").data("placeholder"));
			}
		}

		function initializeCheckboxDropdowns(dropdowns) {
			initializeCustomDropdowns(dropdowns);

			dropdowns
				.each(function () {
					updateCheckboxDropdownState($(this));

				})
				.on("click", ":checkbox", function (evt) {
					let dropdown = $(evt.delegateTarget);

					updateCheckboxDropdownState(dropdown);
				})
				.on("click", ".js-clear-selections-btn", function (evt) {
					let dropdown = $(evt.delegateTarget);

					dropdown.find("input:checked").prop("checked", false);

					dropdown.find("input:checkbox").first().trigger("change");

					updateCheckboxDropdownState(dropdown);
				});
		}

		function initializeCustomDropdowns(dropdowns) {
			dropdowns
				.each(function () {
					$(".dropdown-toggle", this).data(
						"placeholder",
						$(".dropdown-toggle", this).text()
					);

					// If the field is within a collapsible wrapper, open the collapse to show the filters
					$(this).closest(".collapse").addClass("show");

					// Briefly open dropdown menu and make sure clear button is hidden
					$(".dropdown-menu", this)
						.css("max-height", "unset")
						.addClass("show")
						.find(".js-clear-selections-btn")
						.hide();

					// Capture opened height without clear button
					$(".dropdown-menu", this).data(
						"opened-height",
						$(".dropdown-menu", this).outerHeight()
					);

					// Briefly show the clear button
					$(".dropdown-menu", this)
						.find(".js-clear-selections-btn")
						.show();

					// Capture opened height WITH clear button
					$(".dropdown-menu", this).data(
						"opened-height-with-clear",
						$(".dropdown-menu", this).outerHeight()
					);

					// Close the dropdown again and return the clear button to it's original visibility state
					$(".dropdown-menu", this)
						.css("max-height", "")
						.removeClass("show");

					// Close the collapse wrapper again
					$(this).closest(".collapse").removeClass("show");
				})
				.on("show.bs.dropdown", function () {
					if ($(".js-clear-selections-btn", this).is(".show")) {
						$(".dropdown-menu", this).css(
							"max-height",
							$(".dropdown-menu", this).data(
								"opened-height-with-clear"
							)
						);
					} else {
						$(".dropdown-menu", this).css(
							"max-height",
							$(".dropdown-menu", this).data("opened-height")
						);
					}
				})
				.on("hide.bs.dropdown", function () {
					$(".dropdown-menu", this).css("max-height", "");
				})
				.on("click", ".dropdown-menu", function (evt) {
					evt.stopPropagation();
				});
		}
	});
})(jQuery);